import day from './day';
import night from './night';

const themes = { night, day };

export default themes;
